import BasePage from '@/found/components/table_page';

export default {
  name: 'cust_fee',
  extends: BasePage,
  data() {
    return {};
  },
  components: {

  },
  async created() {
    await this.getConfigList('cust_fee');
  },
  methods: {

  },
};
